/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FileUrl
 */
export interface FileUrl {}

/**
 * Check if a given object implements the FileUrl interface.
 */
export function instanceOfFileUrl(value: object): boolean {
    return true;
}

export function FileUrlFromJSON(json: any): FileUrl {
    return FileUrlFromJSONTyped(json, false);
}

export function FileUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileUrl {
    return json;
}

export function FileUrlToJSON(value?: FileUrl | null): any {
    return value;
}
